<template>
  <div style="margin: 0px; padding: 0px;">
    <el-container direction="vertical" class="layout-container">
      <HEAD :active="active"></HEAD>
      <el-main class="el-main-ms">
        <!--图片层-->
        <main-plugin :img-src="imgSrc"></main-plugin>
        <!--图层1-->
        <main-plugin :img-src="imgSrc1"></main-plugin>
<!--        <div class="title-sy"><span style="border-bottom: 1px solid rgb(124, 185, 186);">陌上愿景</span></div>-->
        <carousel-plugin ></carousel-plugin>
        <div class="title-sy"><span style="border-bottom: 1px solid rgb(124, 185, 186);">陌上生态</span></div>
        <div class="div-middle-all" ><img :src="imgSrc2" style="width:80%;height:680px"></div>
<!--        <main-plugin :img-src="imgSrc2"></main-plugin>-->
<!--        <main-plugin style="width: 75%;" :img-src="imgSrc2"></main-plugin>-->
        <!--联系我们-->
        <contact-plugin></contact-plugin>
      </el-main>
      <FOOT></FOOT>
    </el-container>
  </div>
</template>

<script>
import HEAD from "@/views/Head";
import FOOT from "@/views/Foot";
import MainPlugin from "@/components/MainPlugin";
import ContactPlugin from "@/components/ContactPlugin";
import CarouselPlugin from "@/components/CarouselPlugin";

export default {
  name: "MsStrategy",
  metaInfo: {
    title: '陌上酒店集团官网', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '陌上战略'
    },{
      name: 'description',
      content: '陌上规划-集团发展路线、陌上愿景、陌上生态'
    }]
  },
  data() {
    return {
      active: '6',
      imgSrc: require('../assets/images/06-01-01-zl-pg.jpg'),
      imgSrc1: require('../assets/images/06-02-zl-p11.png'),
      imgSrc2: require('../assets/images/06-03-cp-pg.jpg'),
    }
  },
  components: {
    HEAD,
    FOOT,
    MainPlugin,
    ContactPlugin,
    CarouselPlugin
  }
}
</script>

<style scoped>

</style>
